// extracted by mini-css-extract-plugin
export default {"examItem":"_GetExamInfoItem_examItem__gYnVq","examItemLegend":"_GetExamInfoItem_examItemLegend__hNcDZ"};